import { API_ENDPOINTS } from "@/api/services/profile/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const accountInformationApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    fetchAccountInfo: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ACCOUNT_INFORMATION.FETCH_ACCOUNT_INFO,
        method: "GET",
      }),
      providesTags: [{ type: "accountInformation", id: "LIST" }],
    }),

    putAccountInfo: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.ACCOUNT_INFORMATION.EDIT_ACCOUNT_INFO,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "accountInformation", id: "LIST" }],
    }),
    //API FOR HR
    hrFetchAccountInfo: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.ACCOUNT_INFORMATION.HR_FETCH_ACCOUNT_INFO(empId),
        method: "GET",
      }),
      providesTags: [{ type: "hrAccountInformation", id: "LIST" }],
    }),

    hrPutAccountInfo: builder.mutation({
      query: ({ empId, formData }) => ({
        url: API_ENDPOINTS.ACCOUNT_INFORMATION.HR_EDIT_ACCOUNT_INFO(empId),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "hrAccountInformation", id: "LIST" },{ type: "accountInformation", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchAccountInfoQuery,
  usePutAccountInfoMutation,
  useHrFetchAccountInfoQuery,
  useHrPutAccountInfoMutation,
} = accountInformationApi;
